export default __webpack_public_path__ + "static/media/black_empty_checkbox.54beb257.svg";